import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Tracking} from '../../../_models/tracking';
import { User } from '../../../_models/user';
import { Location } from '@angular/common';

import { FormValidator } from '../../../_helpers/form.validator';
import { TrackingValidator } from '../../tracking.validator';

@Component({
  selector: 'app-tracking-edit',
  templateUrl: './tracking-edit.component.html'
})
export class TrackingEditComponent implements OnInit {

  title: string;
  subtitle: string;

  trackingForm: FormGroup;

  actionModal: boolean;
  alertModal: boolean;
  infoModal: boolean;

  actionInfo: string;
  alertInfo: string;
  infoInfo: string;

  current_user_id: number;
  current_username: string;
  current_group_id: number;

  today: Date;

  // Variable para el control de las validaciones del formulario y sus mensajes.
  formValidator: FormValidator;


  @Input() tracking: Tracking;
  @Input() userList: User[];
  @Output() updateTracking = new EventEmitter<Tracking>();
  @Output() showInfoModal = new EventEmitter<{ value: boolean, info: string, link: string, skin: string }>();

  constructor(
    public router: Router,
    private formBuilder: FormBuilder,
    private _location: Location
  ) {
    this.formValidator = new FormValidator();
  }

  // convenience getter for easy access to form fields
  get f() { return this.trackingForm.controls; }

  ngOnInit() {

    // {{ value_expression | sepa_date [ : format [ : timezone [ : locale ] ] ] }}
    // this.today = formatDate(new Date(), 'dd-MM-yyyy hh:mm:ss a', 'en-US', '+0200');
    this.today = new Date();

    this.current_user_id = Number(localStorage.getItem('user_id'));
    this.current_username = localStorage.getItem('username');
    this.current_group_id = Number(localStorage.getItem('group_id'));

    console.log('->->< Tracking-Edit --> Usuario actual logueado: ' + this.current_user_id + ' ;group_id = ' + this.current_group_id);
    console.log(this.current_username);

    if (this.tracking.date === null) {
      this.tracking.date = this.today;
    }

    this.trackingForm = this.formBuilder.group({

      id: this.tracking.id,
      action_id: this.tracking.action_id,
      action_name: [this.tracking.action_name, [Validators.maxLength(45)]],
      user_id: this.tracking.user_id,
      username: [this.tracking.username, [Validators.maxLength(45)]],
      group_id: this.tracking.group_id,
      group_name: [this.tracking.group_name, [Validators.maxLength(45)]],
      enviroment: [this.tracking.enviroment, [Validators.maxLength(45)]],
      company: [this.tracking.company, [Validators.maxLength(45)]],
      permissions: [this.tracking.permissions, [Validators.maxLength(45)]],
      lang: [this.tracking.lang, [Validators.maxLength(4)]],
      table: [this.tracking.table, [Validators.maxLength(20)]],
      field: [this.tracking.field, [Validators.maxLength(20)]],
      type_value: [this.tracking.type_value, [Validators.maxLength(20)]],
      value: [this.tracking.value, [Validators.maxLength(120)]],
      new_value: [this.tracking.new_value, [Validators.maxLength(120)]],
      target_info: [this.tracking.target_info, [Validators.maxLength(40)]],
      date: this.tracking.date
    });

    // Asignamos los mensajes de error asociados a las validaciones que vamos a usar en el formulario.
    this.formValidator.setTemplateMessages(TrackingValidator.templateMessages);

    this.title = 'Módulo de Clientes';
    this.subtitle = 'Edición de Clientes';

    this.actionInfo = '¿Desea guardar el cliente?';

    this.infoInfo = 'La acción se ha realizado correctamente.';

    // Se crean las subscripciones para el control de los campos del formulario.
    this.formValidator.subscribeFormGroup(this.trackingForm);

    if (this.tracking.user_id === null || this.tracking.user_id === undefined) {
      this.trackingForm.controls.user_id.setValue(this.current_user_id);
    }
  } // End function OnInit

  selectDate(): void {
    console.log('---> Cambiando fecha:');
  }

  saveTracking(): void {

    // NOTA: Se copian los cambios sobre la cliente inicial.
    const p = { ...this.tracking, ...this.trackingForm.value };

    this.updateTracking.emit(p);

  } // End function saveTracking

  changeUser(event: any): void {

    console.log('---> Cambiando Agente Comercial:');
    console.log(event);

  } // End function changeUser

  // ------------------------------------
  //    VALIDACIÓN FINAL DEL FORMULARIO
  // ------------------------------------

  validateTracking(): void {

    // Se realizan las comprobaciones pertinentes para confirmar que los campos del formulario son correctos.

    if (this.trackingForm.valid) {
      console.log('-------> Formulario trackingForm correcto.');

      // Comprobaciones que no estén definidas ya en la declaración del formulario.
      if (this.trackingForm.controls.name.value.trim() === '') {

        this.alertInfo = 'Debe de inscribir un nombre.';
        this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});

      } else {
        this.showActionModal(true);
      }
    } else {
      console.log('-------> Formulario trackingForm NO válido:');
      console.log(this.trackingForm);

      this.alertInfo = 'El formulario no está correctamente rellenado:<br>';

      if (this.trackingForm.controls.email.value.trim() === '') {
        this.alertInfo += ' - Debe de inscribir un email y un nombre.<br>';
      }

      this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});
    }
  } // End function validateTracking

  // ------- Función de regreso
  back(): void {
    // this._location.back();
    this.router.navigate(['/tracking']);
  } // End function back

  // -----------------------------------------------
  //  FUNCIONES PARA EL CONTROL DE VENTANAS MODALES
  // -----------------------------------------------

  showActionModal(value: boolean) {
    this.actionModal = value;

  } // End function showActionModal

  confirmActionModal() {

    console.log('--> - -> Confirmada acción del modal.');

    this.saveTracking();

    this.showActionModal(false);
  } // End function confirmActionModal

} // End Class TrackingEditComponent
